// @ts-nocheck
import React from "react";
import { FC } from "react";
import { useMemo } from "react";
import { makeStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core";
import { useSchoolCards } from "./context";
import FontIcon from "../../../../../components/FontIcon";
import { ISchool } from "../../../types";
import IconButton from "../../../../../components/IconButton";

const useStyles = makeStyles((theme: Theme) => ({
  action: {
    padding: theme.spacing(1.2),
    "& .MuiIcon-root": {
      fontSize: theme.spacing(1.5),
    },
  },
}));

const FavoriteIcon: FC<{ school: ISchool }> = ({ school }) => {
  const classes = useStyles();
  const { isLoading, toggleFavorite, favorites } = useSchoolCards();
  const loading = useMemo(() => isLoading.includes(school.id), [isLoading]); // eslint-disable-line react-hooks/exhaustive-deps
  const isFavorite = useMemo(() => favorites.includes(school.id), [favorites]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <IconButton
      disabled={loading}
      onClick={() => toggleFavorite(school.id)}
      className={classes.action}
      color={isFavorite ? "error" : "grey"}
    >
      <FontIcon name="heart" />
    </IconButton>
  );
};

export default FavoriteIcon;
